<template>
  <HelpCenterError :error="error" />
</template>

<script setup>
import { isCancelled } from 'gleam-shared/network/http'
import { ref, onMounted, onUnmounted } from 'vue'
import HelpCenterError from 'help-center/components/HelpCenterError'

const error = ref(null)

onMounted(() => {
  window.addEventListener('error', onError)
  window.addEventListener('unhandledrejection', onError)
})

onUnmounted(() => {
  window.removeEventListener('error', onError)
  window.removeEventListener('unhandledrejection', onError)
})

function onError({ error, reason }) {
  showError(error ?? reason)
}

function showError(value) {
  if (!isCancelled(value)) {
    error.value = value
  }
}
</script>
